import { Capacitor } from '@capacitor/core';

// W przeglądarce API jest pod tym samym hostem (nginx). W aplikacji natywnej – pełny adres serwera.
const NATIVE_API = import.meta.env.VITE_API_URL || 'https://api.deadlodz.pl';

export const API_BASE = Capacitor.isNativePlatform() ? NATIVE_API : (import.meta.env.VITE_API_URL || window.location.origin);
export const WS_BASE = API_BASE.replace(/^http/, 'ws');
export const APP_VERSION = '0.1.0';
